let calculator = {

    StringCalc : (fn) => {
        return new Function('return ' + fn)();
    },

    Init : () => {

        J( "#main_calculator" ).draggable();

        J('#calculator_display').val( 0 );

        Jd.off('click', '.main-top-calc').on('click', '.main-top-calc', function(e){
            if (J('#main_calculator').is(':visible')) {
                J('#main_calculator').hide();
            } else {
                J('#main_calculator').show();
            }
        });

        Jd.off('click', '.calculator-close-btn').on('click', '.calculator-close-btn', function(e){
            J('#main_calculator').hide();
        });

        //calculator-close-btn

        Jd.off('click', '.calculator-equals').on('click', '.calculator-equals', function(e){
            e.preventDefault();
            let string_value = J('#calculator_display_hidden').val();
            J('#calculator_display').val( calculator.StringCalc(string_value) );
            J('#calculator_display_hidden').val( calculator.StringCalc(string_value) );
        });

        Jd.off('click', '.calculator-clear').on('click', '.calculator-clear', function(e){
            e.preventDefault();
            J('#calculator_display').val(0);
            J('#calculator_display_hidden').val(0);
        });

        Jd.off('click', '.calculator-digit').on('click', '.calculator-digit', function(e){
            e.preventDefault();
            let digit_value = J(this).val();
            let current_value = J('#calculator_display').val();
            if (current_value == '0') {
                J('#calculator_display').val( digit_value );
                J('#calculator_display_hidden').val( digit_value );
            } else {
                J('#calculator_display').val( current_value+digit_value );
                J('#calculator_display_hidden').val( current_value+digit_value );
            }
        });

        Jd.off('click', '.calculator-operation').on('click', '.calculator-operation', function(e){
            e.preventDefault();
            let operator_value = J(this).val();
            let current_value = J('#calculator_display').val();
            if (current_value != '0') {
                J('#calculator_display').val( current_value+operator_value );
                J('#calculator_display_hidden').val( current_value+operator_value );
            }
        });

        Jd.off('click', '.calculator-decimal').on('click', '.calculator-decimal', function(e){
            e.preventDefault();
            let operator_value = J(this).val();
            let current_value = J('#calculator_display').val();
            J('#calculator_display').val( current_value+operator_value );
            J('#calculator_display_hidden').val( current_value+operator_value );
        });

        Jd.off('click', '.calculator-pourcentage').on('click', '.calculator-pourcentage', function(e){
            /*e.preventDefault();
            let operator_value = J(this).val();
            let current_value = J('#calculator_display').val();

            let current_value_replace = current_value.replace(/[+*-]/g, '_');
            let current_value_split = current_value_replace.split('_');
            let last_value = current_value_split.pop();

            console.log( current_value_replace );
            console.log( current_value_split );
            console.log( last_value );
            
            if (current_value != '0') {
                J('#calculator_display').val( current_value+operator_value );

                J('#calculator_display_hidden').val( current_value+operator_value );
            }*/
        });
    }
}
module.exports = calculator;